define.alias("shared/components/shared/post/profile-selector", "calendar/components/shared/post/profile-selector/index");